import { render, staticRenderFns } from "./PatientProfilePage.vue?vue&type=template&id=62b16d55&scoped=true"
import script from "./PatientProfilePage.vue?vue&type=script&lang=js"
export * from "./PatientProfilePage.vue?vue&type=script&lang=js"
import style0 from "./PatientProfilePage.vue?vue&type=style&index=0&id=62b16d55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b16d55",
  null
  
)

export default component.exports